import {useHubQuery} from '../../QueryProvider'

export const usePersistedRmcContact = (siteNumber: string) => {
  return useHubQuery('persistedRmcContact', [siteNumber], {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled: !!siteNumber
  })
}
